<template>
  <div class="card">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Liquibase Excecution Status</h3>
        </div>
      </div>
    </div>
    <el-table class="table-responsive table liquibase-table" :data="tableData" :default-sort="{ prop: 'page', order: 'descending' }"
      header-row-class-name="thead-light">
      <el-table-column label="Table Name" min-width="155px" prop="description">
        <template v-slot="{ row }">
          {{ formatTableName(row.description) }}
        </template>
      </el-table-column>
      <el-table-column  class="liquibase-table" label="Date Excecuted" min-width="200px" prop="dateExecuted">
        <template v-slot="{ row }">
          <div class="font-weight-600">{{ formatDateTimestamp(row.dateExecuted) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="Execute Type" min-width="140px" prop="executionType">
        <template v-slot="{ row }">
          <div class="font-weight-600">{{ JSON.parse(row.executionType) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="ChangeLog" min-width="155px" prop="changeLog">
        <template v-slot="{ row }">
          <div class="font-weight-600">{{ JSON.parse(row.changeLog).split('/').pop() }}</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { ElTable, ElTableColumn } from "element-plus";
export default {
  name: "liquibaseDetail",
  components: {
    [ElTable.name]: ElTable,
    [ElTableColumn.name]: ElTableColumn,
  },
  data() {
    return {
      tableData: [],
    };
  },
  methods: {
    formatTableName(description) {
      const match = JSON.parse(description).match(/tableName=([\w_]+)/);
      if (match) {
        const formattedTableName = match[1].split('_')
          .map(word => {
            return /^[a-zA-Z]+$/.test(word)
              ? word.charAt(0).toUpperCase() + word.slice(1).toUpperCase()
              : word;
          })
          .join(' ');
        return formattedTableName;
      }
    },
    getLiquibaseInfo(dataType) {
      let data = {
        type: dataType
      };
      this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
        .then(response => {
          this.tableData = response.server.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    formatDateTimestamp(timestamp) {
      const date = new Date(JSON.parse(timestamp));
      const formattedDate = `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')} ${date.toTimeString().split(' ')[0]}.${date.getMilliseconds().toString().padStart(3, '0')}`;
      return formattedDate;
    },
  },
  mounted() {
    this.getLiquibaseInfo("DB_HISTORY");
  }
};
</script>
<style></style>